import { render } from "./Mail.vue?vue&type=template&id=e01f4c4e"
import script from "./Mail.vue?vue&type=script&lang=js"
export * from "./Mail.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "e01f4c4e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e01f4c4e', script)) {
    api.reload('e01f4c4e', script)
  }
  
  module.hot.accept("./Mail.vue?vue&type=template&id=e01f4c4e", () => {
    api.rerender('e01f4c4e', render)
  })

}

script.__file = "src/icons/components/filled/Mail.vue"

export default script